var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.returnComponent(0),{tag:"component",staticClass:"single landscape",attrs:{"announcement":this.announcements[0],"refreshPeriod":this.refreshPeriod,"isLandscape":true,"isParallel":false,"isPreview":_vm.isPreview}})}
var staticRenderFns = []

export { render, staticRenderFns }